import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { NewsYearRoutingModule } from './news-year-routing.module';
import { NewsYearListComponent } from './news-year-list/news-year-list.component';
import { NewsYearCreateComponent } from './news-year-create/news-year-create.component';

@NgModule({
  declarations: [NewsYearListComponent, NewsYearCreateComponent],
  imports: [
    CommonModule,
    NewsYearRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class NewsYearModule { }
